export default "__VITE_PUBLIC_ASSET__ee4875f9__"